var render = function render(){
  var _vm$task$mainResponsi, _vm$task$createdBy;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "task-box"
  }, [_c('Modal', {
    on: {
      "on-ok": _vm.deleteRecord
    },
    model: {
      value: _vm.deleteRecordModal,
      callback: function ($$v) {
        _vm.deleteRecordModal = $$v;
      },
      expression: "deleteRecordModal"
    }
  }, [_c('p', [_vm._v("您确认要删除此条任务记录吗？")])]), _c('div', {
    staticClass: "task-info-bar"
  }), _c('div', {
    staticClass: "task-area"
  }, [_c('div', {
    staticClass: "col col-small"
  }, [_c('div', {
    staticStyle: {
      "font-size": "12px",
      "color": "rgb(95, 95, 95)"
    }
  }, [_vm._v(" " + _vm._s(_vm.displayDate(_vm.task.createdAt)) + " ")])]), _c('div', {
    staticClass: "col col-small"
  }, [_c('Poptip', {
    attrs: {
      "placement": "right",
      "transfer": ""
    },
    on: {
      "on-popper-show": function ($event) {
        return _vm.searchUserShow('search-user');
      }
    },
    model: {
      value: _vm.searchUserPopVisible,
      callback: function ($$v) {
        _vm.searchUserPopVisible = $$v;
      },
      expression: "searchUserPopVisible"
    }
  }, [_vm.task.mainResponsible ? _c('div', [_vm._v(" " + _vm._s((_vm$task$mainResponsi = _vm.task.mainResponsible) === null || _vm$task$mainResponsi === void 0 ? void 0 : _vm$task$mainResponsi.name) + " ")]) : _c('div', {
    staticStyle: {
      "color": "darkgray"
    }
  }, [_vm._v(" 无 ")]), _c('template', {
    slot: "content"
  }, [_c('Row', [_c('Input', {
    ref: "search-user",
    attrs: {
      "placeholder": "搜索用户",
      "size": "small"
    },
    model: {
      value: _vm.searchUserText,
      callback: function ($$v) {
        _vm.searchUserText = $$v;
      },
      expression: "searchUserText"
    }
  })], 1), _c('div', {
    staticClass: "user-area"
  }, _vm._l(_vm.simpleUserList.filter(function (v) {
    return v.name.includes(_vm.searchUserText);
  }), function (user) {
    return _c('div', {
      staticClass: "user-card"
    }, [_vm._v(" " + _vm._s(user.name) + " ")]);
  }), 0)], 1)], 2)], 1), _c('div', {
    staticClass: "col",
    staticStyle: {
      "width": "593px",
      "font-weight": "700"
    },
    on: {
      "click": function ($event) {
        return _vm.clickField('title');
      }
    }
  }, [_vm.fieldEditing === 'title' ? _c('div', [_c('Input', {
    ref: "input-title",
    attrs: {
      "placeholder": "输入任务标题",
      "border": false,
      "type": "textarea",
      "autosize": {
        minRows: 1,
        maxRows: 30
      }
    },
    on: {
      "on-blur": function ($event) {
        return _vm.finishEditField();
      }
    },
    model: {
      value: _vm.fieldEditingValue,
      callback: function ($$v) {
        _vm.fieldEditingValue = $$v;
      },
      expression: "fieldEditingValue"
    }
  })], 1) : _c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(" " + _vm._s(_vm.task.title) + " ")])]), _c('div', {
    staticClass: "col col-small",
    on: {
      "click": function ($event) {
        return _vm.clickField('deadLine');
      }
    }
  }, [_vm.fieldEditing === 'deadLine' ? _c('div', [_c('Input', {
    ref: "input-deadLine",
    attrs: {
      "placeholder": "时间",
      "border": false,
      "size": "small"
    },
    on: {
      "on-blur": function ($event) {
        return _vm.finishEditField();
      },
      "on-enter": function ($event) {
        return _vm.finishEditField();
      }
    },
    model: {
      value: _vm.fieldEditingValue,
      callback: function ($$v) {
        _vm.fieldEditingValue = $$v;
      },
      expression: "fieldEditingValue"
    }
  })], 1) : _c('div', [_vm.task.deadLine ? _c('div', [_vm._v(" " + _vm._s(_vm.displayDate(_vm.task.deadLine)) + " ")]) : _c('div', {
    staticClass: "gray-out"
  }, [_vm._v(" 无 ")])])]), _c('div', {
    staticClass: "col col-small"
  }, [_c('Dropdown', {
    staticStyle: {
      "margin-right": "12px",
      "cursor": "pointer"
    },
    attrs: {
      "trigger": "click",
      "placement": "bottom-start"
    },
    on: {
      "on-click": _vm.updateTaskProgress
    }
  }, [_vm.progressText[_vm.task.progress] ? _c('div', [_vm._v(" " + _vm._s(_vm.progressText[_vm.task.progress]) + " ")]) : _c('div', {
    staticStyle: {
      "color": "darkgray"
    }
  }, [_vm._v(" 无 ")]), _c('DropdownMenu', {
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_c('DropdownItem', {
    attrs: {
      "name": "created"
    }
  }, [_vm._v("未完成")]), _c('DropdownItem', {
    attrs: {
      "name": "finished"
    }
  }, [_vm._v("已完成")]), _c('DropdownItem', {
    attrs: {
      "name": "canceled",
      "divided": ""
    }
  }, [_vm._v("取消")])], 1)], 1)], 1), _c('div', {
    staticClass: "col col-small"
  }, [_c('Dropdown', {
    staticStyle: {
      "margin-right": "12px",
      "cursor": "pointer"
    },
    attrs: {
      "trigger": "click",
      "placement": "bottom-start"
    },
    on: {
      "on-click": _vm.selectCategory
    }
  }, [_vm.catTrans[_vm.task.category] ? _c('div', {
    staticStyle: {
      "width": "56px",
      "height": "100%"
    }
  }, [_vm._v(" " + _vm._s(_vm.catTrans[_vm.task.category]) + " ")]) : _c('div', {
    staticStyle: {
      "width": "56px",
      "height": "100%",
      "color": "darkgray"
    }
  }, [_vm._v(" 无 ")]), _c('DropdownMenu', {
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_c('DropdownItem', {
    attrs: {
      "name": "sales"
    }
  }, [_vm._v("销售")]), _c('DropdownItem', {
    attrs: {
      "name": "research"
    }
  }, [_vm._v("研发")]), _c('DropdownItem', {
    attrs: {
      "name": "techservice"
    }
  }, [_vm._v("技服")]), _c('DropdownItem', {
    attrs: {
      "name": "factory"
    }
  }, [_vm._v("厂务")]), _c('DropdownItem', {
    attrs: {
      "name": "shipping"
    }
  }, [_vm._v("运输")]), _c('DropdownItem', {
    attrs: {
      "name": "fin"
    }
  }, [_vm._v("财务")]), _c('DropdownItem', {
    attrs: {
      "name": "office"
    }
  }, [_vm._v("总经办")])], 1)], 1)], 1), _c('div', {
    staticClass: "col col-small gray-out"
  }, [_vm._v(" " + _vm._s((_vm$task$createdBy = _vm.task.createdBy) === null || _vm$task$createdBy === void 0 ? void 0 : _vm$task$createdBy.name) + " ")]), _c('div', {
    staticClass: "col",
    staticStyle: {
      "width": "24px",
      "padding": "4px",
      "cursor": "default"
    }
  }, [_c('Icon', {
    staticClass: "delete-btn",
    attrs: {
      "type": "md-trash"
    }
  })], 1)]), _c('Transition', {
    attrs: {
      "name": "btn-row"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showBtnArea,
      expression: "showBtnArea"
    }],
    staticClass: "btn-area"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "icon": "ios-add"
    },
    on: {
      "click": _vm.createNewRecordBtnClicked
    }
  }, [_vm._v("新增进度 ")]), _c('Poptip', {
    attrs: {
      "placement": "top-start"
    },
    on: {
      "on-popper-show": function ($event) {
        return _vm.searchUserShow('search-user-visible');
      }
    },
    model: {
      value: _vm.searchVisbileUserPopVisible,
      callback: function ($$v) {
        _vm.searchVisbileUserPopVisible = $$v;
      },
      expression: "searchVisbileUserPopVisible"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "4px",
      "cursor": "pointer"
    }
  }, [_vm._v(" 可见人：" + _vm._s(_vm.task.visibleMember && _vm.task.visibleMember.length > 0 ? _vm.task.visibleMember.map(function (v) {
    return v.name;
  }).join('、') : '点击添加') + " ")]), _c('template', {
    slot: "content"
  }, [_c('Row', [_c('Input', {
    ref: "search-user-visible",
    attrs: {
      "placeholder": "搜索用户",
      "size": "small"
    },
    model: {
      value: _vm.searchUserText,
      callback: function ($$v) {
        _vm.searchUserText = $$v;
      },
      expression: "searchUserText"
    }
  })], 1), _c('div', {
    staticClass: "user-area"
  }, _vm._l(_vm.simpleUserList.filter(function (v) {
    return v.name.includes(_vm.searchUserText);
  }), function (user) {
    return _c('div', {
      staticClass: "user-card"
    }, [(_vm.task.visibleMember && _vm.task.visibleMember.length > 0 ? _vm.task.visibleMember.map(function (v) {
      return v._id;
    }).includes(user._id) : false) ? _c('div', {
      staticStyle: {
        "color": "blue"
      },
      on: {
        "click": function ($event) {
          return _vm.selectVisibleUser(user._id, 'delete');
        }
      }
    }, [_vm._v(" " + _vm._s(user.name) + " ")]) : _c('div', {
      on: {
        "click": function ($event) {
          return _vm.selectVisibleUser(user._id, 'add');
        }
      }
    }, [_vm._v(" " + _vm._s(user.name) + " ")])]);
  }), 0)], 1)], 2), _vm.newRecordCreating === true ? _c('div', {
    staticStyle: {
      "margin": "4px 12px"
    }
  }, [_c('Input', {
    ref: "new-record",
    attrs: {
      "type": "textarea",
      "placeholder": "输入跟进记录...",
      "rows": _vm.textareaRows
    },
    on: {
      "on-enter": _vm.createNewRecord
    },
    model: {
      value: _vm.newRecordContent,
      callback: function ($$v) {
        _vm.newRecordContent = $$v;
      },
      expression: "newRecordContent"
    }
  }), _c('div', {
    staticStyle: {
      "margin": "8px 0"
    }
  }, [_c('Button', {
    staticStyle: {
      "margin-right": "8px"
    },
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.createNewRecord
    }
  }, [_vm._v("保存")]), _c('Button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function ($event) {
        _vm.newRecordCreating = false;
        _vm.newRecordContent = null;
      }
    }
  }, [_vm._v("取消")])], 1)], 1) : _vm._e()], 1)]), _c('div', _vm._l([].concat(_vm.task.records).reverse(), function (record, index) {
    var _record$createdBy;
    return _c('div', [_c('div', {
      staticClass: "record-row"
    }, [_c('div', {
      staticClass: "col",
      staticStyle: {
        "width": "128px",
        "color": "rgb(95, 95, 95)"
      }
    }, [_vm._v(" " + _vm._s(_vm.displayDate(record === null || record === void 0 ? void 0 : record.createdAt)) + " ")]), _c('div', {
      staticClass: "col",
      staticStyle: {
        "width": "785px"
      },
      on: {
        "click": function ($event) {
          return _vm.clickField('record-content', index);
        }
      }
    }, [_vm.fieldEditing === 'record-content' && _vm.recordEditingIndex === index ? _c('div', [_c('Input', {
      ref: `record-content-${index}`,
      refInFor: true,
      attrs: {
        "placeholder": "输入任务标题",
        "border": false,
        "type": "textarea",
        "autosize": {
          minRows: 1,
          maxRows: 30
        }
      },
      on: {
        "on-blur": function ($event) {
          return _vm.finishEditField();
        }
      },
      model: {
        value: _vm.fieldEditingValue,
        callback: function ($$v) {
          _vm.fieldEditingValue = $$v;
        },
        expression: "fieldEditingValue"
      }
    })], 1) : _c('div', {
      staticStyle: {
        "font-size": "14px"
      }
    }, [_vm._v(" " + _vm._s(record === null || record === void 0 ? void 0 : record.content) + " ")])]), _c('div', {
      staticClass: "col col-small gray-out"
    }, [_vm._v(" " + _vm._s(record === null || record === void 0 ? void 0 : (_record$createdBy = record.createdBy) === null || _record$createdBy === void 0 ? void 0 : _record$createdBy.name) + " ")]), _c('div', {
      staticClass: "col",
      staticStyle: {
        "width": "24px",
        "padding": "4px",
        "cursor": "default"
      }
    }, [_c('Icon', {
      staticClass: "delete-btn",
      attrs: {
        "type": "md-trash"
      },
      on: {
        "click": function ($event) {
          return _vm.openDelRecordModal(record);
        }
      }
    })], 1)])]);
  }), 0)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }